import { UseQueryOptions } from "react-query";
import { API_MODAL_URL } from "src/consts/urls";
import { useQuery } from "src/hooks/react-query/use-query";
import { INewsTradersReactionsResponse } from "./news-traders-reactions.api.types";

interface INewsTraderReactionsQuery {
    underlyingIsin: string;
    slug: string;
    options: UseQueryOptions<INewsTradersReactionsResponse>;
}
export const useNewsTradersReactionsQuery = ({ underlyingIsin, slug, options }: INewsTraderReactionsQuery) => {
    return useQuery<INewsTradersReactionsResponse>(`${API_MODAL_URL}/traderreactions`, {
        ...options,
        queryParams: new URLSearchParams({
            underlyingIsin,
            slug,
        }),
    });
};
